import {BonusFeatureData} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/BonusFeatures";
import {BruteForce} from "../BruteForce";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";

export class BelowStakeWinRestriction {
    public static isWinBelowStake(): boolean {
        return BruteForce.apiPlugin.gameClientConfiguration.belowStakeWinRestriction && (BruteForce.model.data.accumulatedRoundWin <= this.getBuyFeaturePrice());
    }


    public static getBuyFeaturePrice(): number {
        const betLevel: string = BruteForce.apiPlugin.freeBets.hasFreeBets() ? BruteForce.apiPlugin.freeBets.getBet() : BruteForce.apiPlugin.betLevel.getLevel(),
            isFeatureBuy: boolean = this.isFeatureBuy();
        let price: number = BruteForce.model.gameData?.playedBetValue || parseFloat(betLevel);
        if (isFeatureBuy) {
            for (let index: number = 0; index < BruteForce.model.initData.featureBuyTimesBetValue.length; index++) {
                if (BruteForce.model.initData.featureBuyTimesBetValue[index].name === BruteForce.model.buyFeatureName) {
                    price *= BruteForce.model.initData.featureBuyTimesBetValue[index].price;
                    break;
                }
            }
        }
        return price;
    }

    private static isFeatureBuy(): boolean {
        const activeBetFeature: BetFeature | undefined = BruteForce.apiPlugin.betFeatureController.getActiveBetFeature();
        return !!activeBetFeature;
    }
}